export function VirtualTablePaddingRow({ height }: { height: number }) {
  return (
    <tr>
      <td style={{ height: height, padding: 0 }} />
    </tr>
  );
}
